import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Card,
  CardContent,
  CardActions,
  Grid,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { Print } from "@material-ui/icons";
import {
  ValidatorForm,
  SelectValidator,
  TextValidator,
} from "react-material-ui-form-validator";

// import {
//   MuiPickersUtilsProvider,
//   KeyboardDatePicker,
// } from "@material-ui/pickers";
// import DateFnsUtils from "@date-io/date-fns";
// import esLocale from "date-fns/locale/es";
// import moment from "moment";
// import "moment/locale/es";

import { traerAfiliaciones } from "../../../actions/abm/abmAfiliaciones";

import { TIPO_AFILIACION } from "../../../utils/constants";
import { ModalFacturasGeneradas } from "./ModalFacturasGeneradas";

const useStyles = makeStyles({
  select: {
    "&:before": {
      borderColor: "white",
    },
    "&:after": {
      borderColor: "white",
    },
    "&:not(.Mui-disabled):hover::before": {
      borderColor: "white",
    },
  },
  icon: {
    fill: "white",
  },
  root: {
    color: "white",
  },
});

export const FormFacturasGeneradas = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [idtipoAfiliacion, setIdTipoAfiliacion] = useState("");
  // const [fecha, setFecha] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [periodo, setPeriodo] = useState();
  const [modalFacturasGen, setModalFactGen] = useState(false);

  const { items } = useSelector((state) => state.tipoAfiliaciones);

  const tiposAfiliaciones = items
    .filter(
      (item) =>
        item.id_tipo_afiliacion === TIPO_AFILIACION.ADHERENTE ||
        item.id_tipo_afiliacion === TIPO_AFILIACION.TEMPORARIO ||
        item.id_tipo_afiliacion === TIPO_AFILIACION.TEMPORARIO_CON_CUOTA
    )
    .sort((a, b) => {
      if (a.descripcion_afiliacion > b.descripcion_afiliacion) {
        return 1;
      }
      if (a.descripcion_afiliacion < b.descripcion_afiliacion) {
        return -1;
      }
      return 0;
    });
    
  const tipoAfiliacionTodos ={
    id_tipo_afiliacion: 99,
    descripcion_afiliacion: "TODOS",
    idSituacionRevista: 99
  }

  tiposAfiliaciones.unshift(tipoAfiliacionTodos);

  useEffect(() => {
    if (items.length === 0) {
      dispatch(traerAfiliaciones());
    }
  }, [dispatch, items]);

  const closeModalFacturacionGeneradaHandler = () => {
    setModalFactGen(false);
  };

  const openModalFacturacionGeneradaHandler = () => {
    setModalFactGen(true);
  };

  const onChangeTipoAfiliacionHandler = (e) => {
    setIdTipoAfiliacion(e.target.value);
  };

  // const onChangeDateHandler = (date) => {
  //   setFecha(moment(date).format("YYYY-MM-DD"));
  // };

  const onSubmitHandler = async (e) => {
    openModalFacturacionGeneradaHandler();
  };

  const dateNow = new Date();
  const yearNow = dateNow.getFullYear();
  const monthNow = dateNow.getMonth() + 1;

  useEffect(() => {
    ValidatorForm.addValidationRule("periodValid", (value) => {
      if(value){      
        const year = parseInt(value.substring(0, 4));
        const month = parseInt(value.substring(4, 6));

        if (year <= yearNow /* && year > (yearNow-11) */ && month > 0 && month <= 12){
          if(year === yearNow && month > monthNow){
            return false;
          }else{
            return true;
          }
        }
        return false;
      }
      return true;
    });

  });

  return (
    <React.Fragment>
      <ModalFacturasGeneradas
        open={modalFacturasGen}
        onClose={closeModalFacturacionGeneradaHandler}
        idtipoAfiliacion={idtipoAfiliacion}
        periodo={periodo}
        // fecha={fecha}
      />
      <Card>
        <ValidatorForm onSubmit={onSubmitHandler}>
          <CardContent>
            <Typography
              sx={{ fontSize: 14 }}
              style={{ fontWeight: "bold" }}
              color="text.secondary"
              gutterBottom
            >
              Facturas Generadas
            </Typography>
            <Grid
              container
              spacing={2}
              direction="row"
              justifyContent="space-between"
            >
              <Grid item>
                <SelectValidator
                  fullWidth
                  className={classes.select}
                  style={{ width: "14rem" }}
                  margin="normal"
                  label="Tipo de Afiliación"
                  name="idtipoAfiliacion"
                  value={idtipoAfiliacion ? idtipoAfiliacion : ""}
                  onChange={onChangeTipoAfiliacionHandler}
                  validators={["required"]}
                  errorMessages={["Seleccione un tipo de afiliación"]}
                >
                  <MenuItem value="">
                    <em>Seleccione</em>
                  </MenuItem>

                  {tiposAfiliaciones.map((tipo) => (
                    <MenuItem
                      key={tipo.id_tipo_afiliacion}
                      value={tipo.id_tipo_afiliacion}
                    >
                      {tipo.descripcion_afiliacion}
                    </MenuItem>
                  ))}
                </SelectValidator>
              </Grid>
              <Grid item>
                <TextValidator
                    margin="normal"
                    value={periodo}
                    // disabled={props.disabled}
                    onChange={(e) => setPeriodo(e.target.value)}
                    fullWidth
                    label="Periodo (YYYYMM)"
                    name="nro_traspaso"
                    autoComplete="off"
                    inputProps={{ maxLength: 6}}
                    // InputLabelProps={{ shrink: true }}  
                    validators={[
                      "required", 
                      "isNumber", 
                      "minNumber:99999",
                      "periodValid",
                    ]}
                    errorMessages={[
                      "Este campo es obligatorio",
                      "Solo números",
                      "Verifique el Periodo",
                      "Verifique el Periodo",   // `El periodo debe ser menor o igual al actual, el año debe ser mayor a ${yearNow-11} y el mes debe ser menor a 13`,
                    ]}
                />
                {/* <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    style={{ width: "14rem" }}
                    margin="normal"
                    format="dd/MM/yyyy"
                    required={true}
                    label="Fecha"
                    okLabel="Aceptar"
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    id="dialogFecha"
                    maxDate={new Date()}
                    value={moment(fecha).isValid() ? moment(fecha) : new Date()}
                    onChange={(date) => {
                      onChangeDateHandler(date);
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider> */}
              </Grid>
            </Grid>
          </CardContent>
          <CardActions
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "0.5rem",
              marginTop: "1rem",
            }}
          >
            <Button
              type="submit"
              size="small"
              color="secondary"
              variant="contained"
              className={classes.button}
              startIcon={<Print />}
            >
              IMPRIMIR
            </Button>
          </CardActions>
        </ValidatorForm>
      </Card>
    </React.Fragment>
  );
};
